import { ButtonVariants } from 'components/shared/StyledButton/StyledButton';

export const getButtonLoaderColor = (variant: ButtonVariants) => {
   switch (variant) {
      case 'filled-primary':
         return 'white';
      case 'outlined-primary':
         return 'var(--light-green)';
   }
};
